import { render, staticRenderFns } from "./task_status.vue?vue&type=template&id=c8a86d22&scoped=true"
import script from "./task_status.vue?vue&type=script&lang=js"
export * from "./task_status.vue?vue&type=script&lang=js"
import style0 from "./task_status.vue?vue&type=style&index=0&id=c8a86d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a86d22",
  null
  
)

export default component.exports